module.exports = __webpack_public_path__ + "img/transaction.da18b5a6.png";